import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import { wrapEventHandler } from './Event.utils';
import { ChildrenPropType } from '../../../../services/proptypes';
import { EventPropType } from '../../types';
var defaultProps = {};
export default function Event(_ref) {
  var event = _ref.event,
    eventType = _ref.eventType,
    children = _ref.children;
  if (_isEmpty(event)) {
    return children;
  }
  return /*#__PURE__*/React.cloneElement(children, _objectSpread(_objectSpread({}, children.props), wrapEventHandler(event, eventType, children)));
}
Event.defaultProps = defaultProps;